import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import { useEffect, useState } from "preact/hooks"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

function ToggleMobileSidebarButton({ labelFor, selectedFiltersCount, className }) {
    return (
        <label for={labelFor} class={`ns-d-flex ns-align-items-center ${className}`}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 12a2.5 2.5 0 1 0-2.421-3.125H6.625a.625.625 0 1 0 0 1.25h6.954A2.501 2.501 0 0 0 16 12zm-1.25-2.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0zM6 14.5a2.5 2.5 0 0 1 4.921-.625h6.954a.625.625 0 1 1 0 1.25h-6.954A2.501 2.501 0 0 1 6 14.5zm3.75 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z" fill="currentColor"></path>
            </svg>
            <span>Filter</span>
            <span className="ns-ml-1">
                ({selectedFiltersCount})
            </span>
        </label>
    )
}

export default function Toolbar({ labelFor, setOpenedSidebar, openedSidebar }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()
    const [open, setOpen] = useState(false)

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} results` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    if(open){
        document.querySelector("body").addEventListener("click", function(e){
            if(e.target !== document.querySelector(".ns-sorting-options") && !document.querySelector(".ns-sorting-options").contains(e.target) && e.target !== document.getElementById("nosto-sortby")){
                setOpen(false)
            }
        })
    }

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-row ns-flex-wrap align-center ns-justify-content-between"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-d-md-flex ns-order-md-first ns-align-self-md-center ns-results-total"
                    data-nosto-element="totalResults"
                >   
                    <button class="ns-d-none ns-align-items-center ns-d-l-flex" onClick={() => setOpenedSidebar(!openedSidebar)}>
                        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 12a2.5 2.5 0 1 0-2.421-3.125H6.625a.625.625 0 1 0 0 1.25h6.954A2.501 2.501 0 0 0 16 12zm-1.25-2.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0zM6 14.5a2.5 2.5 0 0 1 4.921-.625h6.954a.625.625 0 1 1 0 1.25h-6.954A2.501 2.501 0 0 1 6 14.5zm3.75 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z" fill="currentColor"></path>
                        </svg>
                        <span>Filter</span>
                        <span className="ns-ml-1">
                            ({selectedFiltersCount})
                        </span>
                    </button>
                    <span>{totalSummary}</span>
                </span>
            )}
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-l-block">
                <ToggleMobileSidebarButton
                    labelFor={labelFor}
                    selectedFiltersCount={selectedFiltersCount}
                    className={"ns-d-l-none"}
                />
                <button
                  class="group flex flex-row items-center justify-center text-[11px] md:text-[15px] nosto-sort-button"
                  id="nosto-sortby"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded={open}
                  data-headlessui-state=""
                  onClick={() => setOpen(!open)}
                >
                    Sort By 
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" class="ml-2"><path d="m12 14 4-4H8z" fill-rule="evenodd"></path></svg>
                </button>
                <div 
                   aria-labelledby="nosto-sortby" 
                   class="z-[20] ns-sorting-options origin-top-right absolute right-0 mt-2 w-[12rem] lg:w-60 focus:outline-none bg-white border border-gray-05 text-[15px] text-black font-normal p-2"
                   role="menu"
                   tabindex="0"
                   data-headlessui-state=""
                   aria-expanded={open}
                >
                    <Select
                        value={activeSort}
                        onChange={e => handleSortChange(e)}
                        className="ns-selection-dropdown-sort-menu"
                        options={options}
                    />
                </div>
            </div>
        </div>
    )
}
